import 'bootstrap/dist/css/bootstrap.min.css';
import './navbar.css'
import { AiOutlineInstagram, AiOutlineCopyrightCircle,AiFillLinkedin } from 'react-icons/ai';
import { BsFillTelephoneFill } from 'react-icons/bs';
import { GrMail } from 'react-icons/gr';
import Fade from 'react-reveal/Fade';

import { useState } from 'react';
import Home from '../Home/home';
import Filmography from '../Filmography/filmography';
import About from '../About/about';
import Achievements from '../Achievements/Achievements';

export default function Navbar(){
    const [page, setPage] = useState(<Home/>);
    const [pageName, setPageName] = useState('Home');
    
    function changePage(x, y){
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'auto'
          });
        setPage(x);
        setPageName(y);
    }

    return(
        <div className='m-custom'>
            <nav className='d-flex align-items-center justify-content-between py-3 sticky-top'>
                <Fade left>
                    <img onClick={()=>changePage(<Home/>,'Home')} src="./logo.png" alt="logo" />
                </Fade>
                <Fade right>
                    <div className='d-flex gap-3'>
                        <h3 onClick={()=>changePage(<Home/>,'Home')} className={pageName === 'Home' ? '' : 'text-muted'}>Home</h3>
                        <h3 onClick={()=>changePage(<Filmography/>,'Filmography')} className={pageName === 'Filmography' ? '' : 'text-muted'}>Filmography</h3>
                        <h3 onClick={()=>changePage(<About/>,'About')} className={pageName === 'About' ? '' : 'text-muted'}>About</h3>
                        <h3 onClick={()=>changePage(<Achievements/>,'Achievements')} className={pageName === 'Achievements' ? '' : 'text-muted'}>Achievements</h3>
                    </div>
                </Fade>
            </nav>

            {page}

            <footer>
                <h1 id='hubungi-saya' className='mb-5 text-oren'>Hubungi Saya</h1>
                <div id='hubungi-saya-content' className='d-flex justify-content-between pb-3 border-3 border-bottom'>
                    <div className='d-flex flex-column gap-2'>
                        <a href='mailto:dominic@student.umn.ac.id'><GrMail className='me-2'/> dominic@student.umn.ac.id</a>
                        <a href='https://www.instagram.com/dom.chrs/' target='_blank' rel='noreferrer'><AiOutlineInstagram className='me-2'/> @dom.chrs</a>
                        <a href='#a' target='_blank' rel='noreferrer'><AiFillLinkedin className='me-2'/> linkedin.com<span>/</span>dominic-christiansen</a>
                        <a href='tel:+6287885979197'><BsFillTelephoneFill className='me-2'/> +62878-8597-9197</a>
                    </div>
                </div>
                    <div className='d-flex justify-content-center align-items-center mt-3'>
                        <AiOutlineCopyrightCircle className='me-2'/>2022 Dominic Christiansen
                    </div>
            </footer>
        </div>
    )
}